export default "__VITE_ASSET__FEKvlxMZ__"